import { computed, observable } from "mobx";
import { Type } from "class-transformer";
import BankCodeType from "./bankCodeType";
import CounterpartyBankAccountRequest from "./counterpartyBankAccountRequest";
import type { IBankAccount } from "./types";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class TransferRefundCounterpartyBankRequest {
  @observable
  @Type(() => CounterpartyBankAccountRequest)
  bankAccount?: CounterpartyBankAccountRequest;

  /**
   * Counterparty name.
PRZ - 0 - 35 T
   */
  @observable
  name?: string;

  /**
   * Counterparty city address.
PRZ 0 - 35 T
   */
  @observable
  cityAddress?: string;

  /**
   * Counterparty country ID.
   */
  @observable
  countryId?: string;

  @observable
  codeType?: BankCodeType;
}

export default class TransferRefundCounterpartyBank extends TransferRefundCounterpartyBankRequest implements IBankAccount {
  @computed
  get accountNumber() {
    return this.bankAccount?.accountNumber;
  }

  set accountNumber(accountNumber) {
    if (!this.bankAccount) {
      this.bankAccount = new CounterpartyBankAccountRequest();
    }
    this.bankAccount.accountNumber = accountNumber;
  }

  @computed
  get bank() {
    return this.bankAccount?.bank ?? "";
  }

  set bank(bank) {
    if (!this.bankAccount) {
      this.bankAccount = new CounterpartyBankAccountRequest();
    }

    this.bankAccount.bank = bank;
  }
}
